import {
  Button,
  Collapse,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import PropTypes from "prop-types";
import {
  baseUrl,
  endpoints,
  fileTreeEntityType,
  findInTree,
} from "../../utils/config";
import FolderListItem from "./FolderListItem";
import FolderIcon from "@mui/icons-material/Folder";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { getToken } from "../../utils/API/authMethods";
import { find } from "lodash";
import { useStore } from "../../hooks/store";
export default function FolderList({
  listData,
  handleFileSelect,
  hanldeFolderSelect,
  selectedFile,
  selectedFolder,
}) {
  const setAlert = useStore((state) => state.setAlert);
  const renderItem = (item, index) => {
    if (!item) {
      return <></>;
    }
    const handleFolderClick = () => {
      hanldeFolderSelect(item);
    };
    const handleFileClick = () => {
      handleFileSelect(item);
    };
    const { type, name, id } = item;

    if (type === fileTreeEntityType.folder) {
      return (
        <ListItem
          key={id}
          style={{
            flexDirection: "column",
            width: "100%",
            alignItems: "flex-start",
          }}>
          <ListItemButton
            id={id}
            disabled={name === "img"}
            onClick={handleFolderClick}
            style={{ width: "100%" }}>
            <ListItemIcon>
              <FolderIcon />
            </ListItemIcon>
            <ListItemText primary={name} />
            {index === 0 || selectedFolder.id === id ? (
              <ExpandLess />
            ) : (
              <ExpandMore />
            )}
          </ListItemButton>
          <Collapse
            component={"div"}
            in={index === 0 || selectedFolder.id === id}
            timeout={"auto"}
            unmountOnExit
            style={{ width: "100%" }}>
            {item.children.map((chdItm) => renderItem(chdItm))}
          </Collapse>
        </ListItem>
      );
    } else {
      return (
        <FolderListItem
          id={id}
          name={name}
          selectedFile={selectedFile}
          handleFileSelect={handleFileClick}
        />
      );
    }
  };

  const handleURLCopy = () => {
    const url =
      "https://pyatnashka.md/api_2" +
      "/image" +
      `/${selectedFolder.name}/${selectedFile.name}`;
    setAlert("Текст скопирован");
    navigator.clipboard.writeText(url);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
      }}>
      <List
        style={{
          overflowY: "scroll",
          display: "flex",
          height: 250,
        }}>
        {listData.map((listItem, index) => renderItem(listItem, index))}
      </List>
      <div
        style={{
          marginLeft: 40,
          marginRight: 40,

          display: "flex",
          flexDirection: "column",
          justifyContent: "space-around",
        }}>
        {selectedFolder.id && selectedFile.id ? (
          <div
            style={{
              border: "1px solid #dedede",
              width: 150,
              aspectRatio: 1 / 1,
              height: "auto",
              padding: 10,
              borderRadius: 5,
              alignItems: "center",
              display: "flex",
              justifyContent: "center",
            }}>
            <img
              style={{
                objectFit: "contain",
                maxWidth: 130,
                // aspectRatio: 1 / 1,
              }}
              src={
                endpoints.image +
                "/" +
                selectedFolder.name +
                "/" +
                selectedFile.name +
                `?jwt=${getToken()}`
              }
              //   width={50}
              //   height={50}
              alt="id"
              handleURLCopy
            />
          </div>
        ) : (
          <div
            style={{
              border: "1px solid #dedede",
              width: 150,
              aspectRatio: 1 / 1,
              height: "auto",
              padding: 10,
              borderRadius: 5,
              alignItems: "center",
              display: "flex",
              justifyContent: "center",
            }}>
            <p style={{ textAlign: "center" }}>
              Выберите изображение для предпросмотра
            </p>
          </div>
        )}
        <Button
          variant="contained"
          disabled={!(selectedFolder.id && selectedFile.id)}
          onClick={handleURLCopy}>
          Копировать URL
        </Button>
      </div>
    </div>
  );
}

FolderList.propTypes = {
  listData: PropTypes.array,
  handleFileSelect: PropTypes.func,
  hanldeFolderSelect: PropTypes.func,
  selectedFolder: PropTypes.string,
  selectedFile: PropTypes.string,
};
